module.exports = __webpack_public_path__ + "static/media/vf_wdress_core.470bb4d3.svg";